export type CompanyQueryKeyParams = {
  companyLinkedinId?: string;
  domain?: string;
};

const COMPANY_KEY = 'company';

const makeTopCountriesQueryKey = ({ companyLinkedinId, domain }: CompanyQueryKeyParams) => [
  COMPANY_KEY,
  'top-countries',
  companyLinkedinId,
  domain?.toLowerCase(),
];

const makeCompanyQueryKey = ({ companyLinkedinId, domain }: CompanyQueryKeyParams) => [
  COMPANY_KEY,
  companyLinkedinId,
  domain?.toLowerCase(),
];

const makeCompaniesQueryKey = (domains: string[]) => [COMPANY_KEY, ...domains];

const makeCompanyCrmInfoQueryKey = (domain: string) => [COMPANY_KEY, 'crm-info', domain?.toLowerCase()];

const companyQueryKey = {
  company: makeCompanyQueryKey,
  companies: makeCompaniesQueryKey,
  topCountries: makeTopCountriesQueryKey,
  companyCrmInfo: makeCompanyCrmInfoQueryKey,
  ecommerceReportStatus: (domain: string) => [COMPANY_KEY, 'ecommerce-report-status', domain],
};

export default companyQueryKey;
